import { Admin, DashUser } from "@/router";

export default [
    {
        path: "/",
        redirect: "/admin/home"
    },
    {
        path: "/admin/home",
        name: "home",
        components: {
            default: () => import("@admin/home/Home.vue")
        },

        meta: () => ({
            pageTitle: "الرئيسية",
            roles: [Admin, DashUser],
            layout: "vertical"
        })
    },
    {
        path: "/admin/user",
        name: "user",
        components: {
           default: () => import("@admin/user/user.vue"),
           actions: () => import("@admin/user/components/AddUser.vue"),
        },
        meta: () => ({
            pageTitle: "المستخدمين",
            roles: [Admin, DashUser],
            layout: "vertical",
            breadcrumb: [
                {
                    icon: "users-alt",
                    text: "المستخدمين"
                }
            ]
        })
    },
    {
        path: "/admin/user/:id",
        props: true,
        name: "user",
        component: () =>
            import("@admin/user/pages/detailsUser.vue"),
        meta: () => ({
            pageTitle: "تفاصيل مستخدم",
            roles: [Admin, DashUser],
            layout: "vertical",
            breadcrumb: [
                {
                    icon: "users-alt",
                    text: "المستخدمين",
                    to: "/admin/user"
                },
                {
                    text: "تفاصيل المستخدم",
                    active: true
                }
            ]
        })
    },
];
